
export const Tmapkey = '3EWBZ-TXH6I-RM4GS-UM2AC-CAWIJ-J5BJM'

export const Tmapversion = '1.exp'